import '../../vendor/clickmenu.js';

export function setupMenu(): void {
  const menuToggle = document.querySelector('.menu-toggle');
  $('.main-nav.drawer-nav').clickMenu({ htmlClass: 'drawer-nav-active' });
  $('.main-nav .cm-menu > li[data-styled-format="False"]').first().addClass('styled-format-false');

  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      const html = document.querySelector('html');
      if (html?.classList.contains('drawer-nav-active')) {
        html?.classList.remove('drawer-nav-active');
      } else {
        html?.classList.add('drawer-nav-active');
      }
    });
  }
}
